export const BASE_SLOS_PAGE_SIZE = 10;
export const NON_COHORT_PREFIX = 'non-';
